package com.klantenstop.web.data.models.domain

import com.klantenstop.web.data.models.dto.responses.ReviewTotalDto

data class ReviewTotal(
    val total: Int = 0,
    val average: Double = 0.0
)

fun ReviewTotalDto.toReviewTotal() = ReviewTotal(
    total = total,
    average = average
)
